module.exports = __webpack_public_path__ + "img/20210420_120041.71a1147b.jpg";